module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2019/october-702630558c837fbba28454982c6387ab.png";